module.exports = __webpack_public_path__ + "img/security2-logo41.493456ed.png";